import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUpload as Upload } from 'react-icons/fa';
import { IoImage as ImageIcon } from 'react-icons/io5';

export default function UploadTool({ fileInputRef, handleImageUpload }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-500 overflow-hidden border border-gray-100">
      <div className="p-8 flex flex-col items-center justify-center text-center">
        <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-6 transition-all duration-500 hover:bg-blue-100">
          <Upload size={36} className="text-blue-600" />
        </div>
        <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('tool.upload.title')}</h3>
        <p className="text-gray-500 mb-8 max-w-md">
          {t('tool.upload.subtitle')}
        </p>
        <label
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 shadow-sm hover:shadow cursor-pointer flex items-center gap-2"
        >
          <ImageIcon size={18} />
          {t('tool.upload.selectFile')}
        </label>
        <input
          type="file"
          ref={fileInputRef}
          accept="image/*"
          onChange={handleImageUpload}
          className="hidden"
        />

        <div className="mt-8 text-sm text-gray-500">
          <p>{t('tool.upload.supportedFormats')}</p>
        </div>
      </div>
    </div>
  );
}